<div class="mt-16 page-container">
    <div fxLayout="row" fxFlex="60">
        <div fxLayout="column" fxLayoutAlign="start none" style="width: 100% !important">
            <div fxLayout="column" class="summary-card">
                <!-- Title -->
                <span class="summary-title">{{ "APP_CASES.CASE_SUMMARY" | translate }}</span>

                <p class="summary-subtitle">
                    {{ "APP_CASES.CASE_SUMMARY_SUB_TITLE" | translate }}
                </p>

                <!-- Stats -->
                <div fxLayout="row" fxLayoutGap="50px" class="summary-stats">
                    <p>
                        {{ "APP_CASES.OFFERS" | translate }} :
                        <span>{{ managementSummaryInfo.caseDocumentTypesSummary.Offers }}</span>
                    </p>
                    <p>
                        {{ "APP_CASES.INVOICES" | translate }} :
                        <span>{{ managementSummaryInfo.caseDocumentTypesSummary.Invoices }}</span>
                    </p>
                    <p>
                        {{ "APP_CASES.PHOTOS" | translate }} :
                        <span>{{ managementSummaryInfo.caseDocumentTypesSummary.Photos }}</span>
                    </p>
                    <p>
                        {{ "APP_CASES.MISC" | translate }} :
                        <span>{{ managementSummaryInfo.caseDocumentTypesSummary.Misc }}</span>
                    </p>
                </div>

                <!-- Total Amount -->
                <div class="total-amount" fxLayout="row">
                    <strong>{{ "APP_CASES.TOTAL_AMOUNT" | translate }} :</strong>
                    <span class="highlight" *ngIf="managementSummaryInfo.totalAmount != null"
                        >{{ managementSummaryInfo.totalAmount | swissCurrency: true }}</span
                    >
                    <mat-spinner
                        class="ml-8 spinner"
                        [diameter]="20"
                        *ngIf="managementSummaryInfo.totalAmount == null"
                    ></mat-spinner>
                </div>

                <!-- Affected Trades -->
                <div class="affected-trades" fxLayout="row" fxLayoutAlign>
                    <strong class="affected-trades-level">{{ "APP_CASES.AFFECTED_TRADES" | translate }} :</strong>
                    <p class="affected-trades-content" *ngIf="managementSummaryInfo.stringTrades != null">
                        {{ managementSummaryInfo.stringTrades != "" ? managementSummaryInfo.stringTrades : "N/A" }}
                    </p>
                    <mat-spinner
                        fxLayoutAlign="start center"
                        class="ml-8 trade-spinner"
                        [diameter]="20"
                        *ngIf="managementSummaryInfo.stringTrades == null"
                    ></mat-spinner>
                </div>

                <!-- Service Provider Section -->
                <p class="service-provider-title">
                    <strong>{{ "APP_CASES.SERVICE_PROVIDER" | translate }}</strong>
                </p>
                <div fxLayout="row" class="service-providers">
                    <div fxLayout="row wrap" class="service-provider-grid">
                        <div
                            *ngFor="
                                let serviceProvideDetail of managementSummaryInfo.serviceProvideDetails;
                                let i = index
                            "
                            fxLayout="column"
                            fxLayoutAlign="start start"
                            class="provider"
                            fxLayoutGap="5px"
                        >
                            <div class="service-provider-spinner" fxLayoutAlign="center center">
                                <mat-progress-bar
                                    class="checked-case-progress-bar"
                                    *ngIf="isCheckedCaseLoading"
                                    mode="indeterminate"
                                    fxLayoutAlign="start start"
                                ></mat-progress-bar>
                            </div>
                            <div
                                fxLayout="row"
                                fxLayoutAlign="space-between center"
                                fxLayoutGap="5px"
                                class="service-provider-content"
                            >
                                <mat-icon fxFlexAlign="baseline">location_city</mat-icon>
                                <p
                                    class="provider-name"
                                    fxFlexAlign="end"
                                    matTooltipPosition="above"
                                    [matTooltip]="serviceProvideDetail?.serviceProviderInfo?.serviceProvider?.name"
                                >
                                    {{ serviceProvideDetail?.serviceProviderInfo?.serviceProvider?.name }}
                                </p>
                            </div>
                            <p
                                class="provider-status"
                                fxLayoutAlign="start start"
                                *ngIf="
                                    !isCheckedCaseLoading &&
                                    serviceProvideDetail.ipexServiceProviderCount !== null &&
                                    serviceProvideDetail?.ipexServiceProviderCount?.connectedCaseCount !== 0
                                "
                            >
                                ✔
                                {{
                                    "APP_CASES.CHECKED_CASES"
                                        | translate
                                            : {
                                                  count:
                                                      serviceProvideDetail?.ipexServiceProviderCount
                                                          ?.connectedCaseCount || 0
                                              }
                                }}
                            </p>
                            <p
                                class="provider-status"
                                fxLayoutAlign="start start"
                                *ngIf="
                                    (!isCheckedCaseLoading && !serviceProvideDetail.ipexServiceProviderCount) ||
                                    serviceProvideDetail?.ipexServiceProviderCount?.connectedCaseCount == 0
                                "
                            >
                                {{ "APP_CASES.NO_CHECKED_CASES" | translate }}
                            </p>
                            <p class="provider-status" fxLayoutAlign="start center" *ngIf="isCheckedCaseLoading">
                                {{ "APP_CASES.LOADING" | translate }}
                            </p>
                        </div>
                        <mat-spinner
                            fxLayoutAlign="center center"
                            class="custom-spinner"
                            [diameter]="30"
                            *ngIf="isServiceProviderLoading"
                        ></mat-spinner>
                        <span
                            class="not-found"
                            *ngIf="
                                !isServiceProviderLoading && managementSummaryInfo.serviceProvideDetails?.length == 0
                            "
                        >
                            {{ "N/A" }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div fxLayout="row" fxFlex="40">
        <mat-card class="custom-mat-card" fxLayout="column" fxLayoutAlign="start none">
            <mat-card-header>
                <mat-card-title>{{ "APP_CREATE_CASE.DAMAGE_LOCATION" | translate }}</mat-card-title>
                <mat-card-subtitle>{{ serviceAddress }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <app-google-map [addresses]="[serviceAddress]"></app-google-map>
            </mat-card-content>
        </mat-card>
    </div>
</div>
